import { mapDefaultRequestFields } from 'stores/adapters/bex-api/migration-adapters/search/sort-and-filter';

import { DefaultRequestFields } from 'models';

import { FullPropertySearch } from '__generated__/api';

export const getDefaultRequestFields = (
  searchCriteria: FullPropertySearch.SearchCriteria,
  region: FullPropertySearch.Region,
  multiItemId: string
): DefaultRequestFields | null => {
  let defaultRequestFields = mapDefaultRequestFields(
    {
      startDate: getDateStringFromDateRange(searchCriteria.dateRange.checkInDate),
      endDate: getDateStringFromDateRange(searchCriteria.dateRange.checkOutDate),
      regionId: region.id
    },
    searchCriteria
  );

  if (searchCriteria.searchIntent) {
    defaultRequestFields = {
      ...defaultRequestFields,
      ...searchCriteria.searchIntent
    };
  }

  if (multiItemId) {
    defaultRequestFields.misId = multiItemId;
  }

  return defaultRequestFields;
};

/**
 * Javascript Date objects require a month index which is why we need minus 1
 * TODO: Add date string logic to the BEX API SDK
 */
export const getDateStringFromDateRange = (dateRange: FullPropertySearch.CheckInDate | FullPropertySearch.CheckOutDate): string =>
  new Date(Date.UTC(dateRange.year, dateRange.month - 1, dateRange.day)).toISOString().split('T')[0];
